

import React from 'react';
import styled from 'styled-components';
import { FaSignOutAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useProfile } from '../context/ProfileContext';

const HeaderWrapper = styled.header`
  width: 100%;
`;

const TopBorder = styled.div`
  width: 100%;
  height: 10px;
  background: #29443e;
`;

const MainHeader = styled.div`
  width: 100%;
  background: #8ab7a6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  min-height: 70px;
  box-sizing: border-box;
  position: relative;

  @media (max-width: 600px) {
    padding: 0 12px;
    min-height: 56px;
  }
`;

const Logo = styled.div`
  font-size: 2.2rem;
  font-weight: bold;
  color: #fff;
  letter-spacing: 2px;
  z-index: 2;

  @media (max-width: 600px) {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.4rem;
  }
`;

const CenterInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  z-index: 1;

  @media (max-width: 600px) {
    position: relative;
    left: 0;
    right: 0;
    margin: 0 auto;
    min-width: 120px;
    font-size: 0.9rem;
  }
`;

const Username = styled.div`
  font-size: 1.2rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 2px;
  @media (max-width: 600px) {
    font-size: 1rem;
  }
`;

const Chips = styled.div`
  font-size: 1rem;
  color: #fff;
  font-weight: 600;
  @media (max-width: 600px) {
    font-size: 0.9rem;
  }
`;

const Expo = styled.div`
  font-size: 1rem;
  color: #fff;
  font-weight: 600;
  @media (max-width: 600px) {
    font-size: 0.9rem;
  }
`;

const LogoutButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-size: 1.2rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  outline: none;
  z-index: 2;

  @media (max-width: 600px) {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1rem;
    gap: 4px;
    padding: 0;
  }
`;

const Header = () => {
  const navigate = useNavigate();
  const { profile } = useProfile();
  const handleLogout = () => {
    navigate('/login');
  };

  return (
    <HeaderWrapper>
      <MainHeader>
        <Logo onClick={()=>navigate('/')}>YOX9</Logo>
        <CenterInfo>
          <Username>{profile.userNo}</Username>
          <Chips>Chips:{profile.walletBalance}</Chips>
          <Expo>Expo:{((profile.exposureBalance || 0) + (profile.sessionexposure || 0))}</Expo>
        </CenterInfo>
        <LogoutButton onClick={handleLogout}>
          <FaSignOutAlt size={20} /> LOGOUT
        </LogoutButton>
      </MainHeader>
    </HeaderWrapper>
  );
};

export default Header;
